import BasicPillar from './BasicPillar.jsx'

/**
 * AI Systems pillar.
 *
 * 3 goals covering internal AI tooling, automations, and Trust Enforcer
 * AI features.
 */
export default function AiSystemsPillar() {
  return (
    <BasicPillar
      pillarId="ai"
      description={
        'Q2 2026 internal AI tooling and automations that compound the rest of the business.'
      }
    />
  )
}
